/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronUpLeft = createReactComponent("chevron-up-left", "IconChevronUpLeft", [
  ["path", { d: "M8 16v-8h8", key: "svg-0" }]
]);

export { IconChevronUpLeft as default };
//# sourceMappingURL=IconChevronUpLeft.js.map
